import { render } from "./OrgPrivacyDetailsForm.vue?vue&type=template&id=c43b03ea&scoped=true"
import script from "./OrgPrivacyDetailsForm.vue?vue&type=script&lang=js"
export * from "./OrgPrivacyDetailsForm.vue?vue&type=script&lang=js"

import "./OrgPrivacyDetailsForm.vue?vue&type=style&index=0&id=c43b03ea&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c43b03ea"]])

export default __exports__